// src/components/MenuAppBar.js
import React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import {
  faMapMarkerAlt,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

export default function MenuAppBar({ drawerWidth, onClickMenuButton }) {
  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: { md: `${drawerWidth}px)` },
        ml: { md: `${drawerWidth}px` },
      }}
    >
      <Toolbar>
        {/* Menu button on mobile */}
        <IconButton
          color="inherit"
          onClick={onClickMenuButton}
          size="large"
          sx={{
            mr: 2,
            display: { md: 'none' },
          }}
        >
          <MenuIcon />
        </IconButton>

        {/* Title for mobile / desktop */}
        <Box component="span" sx={{ display: { xs: 'block', md: 'none' } }}>
          <Link
            to="/"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            <Typography variant="h6">
              Pizzería Italia
            </Typography>
          </Link>
        </Box>
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, textAlign: 'center', width: '100%' }}>
          <Link
            to="/"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            <Typography variant="h6">
              Pizzería Italia - Auténtica Receta Italiana
            </Typography>
          </Link>
        </Box>

        {/* Spacer + social icons */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <IconButton
            color="inherit"
            href="https://www.instagram.com/pizzeriaitaliastgo"
            target="_blank"
            size="large"
            sx={{ fontSize: 20 }}
          >
            <FontAwesomeIcon icon={faInstagram} />
          </IconButton>
          <IconButton
            color="inherit"
            href="https://www.facebook.com/pizzeriaitaliastgo"
            target="_blank"
            size="large"
            sx={{ fontSize: 20 }}
          >
            <FontAwesomeIcon icon={faFacebookF} />
          </IconButton>
          <IconButton
            color="inherit"
            href="tel:+56228959808"
            size="large"
            sx={{ fontSize: 20 }}
          >
            <FontAwesomeIcon icon={faPhone} />
          </IconButton>
          <IconButton
            color="inherit"
            href="https://goo.gl/maps/n4BrsaYuMNxNBejd6"
            target="_blank"
            size="large"
            sx={{ fontSize: 20 }}
          >
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
}